import { render, staticRenderFns } from "./AdminMainScreen.vue?vue&type=template&id=5b9a6182&scoped=true&"
import script from "./AdminMainScreen.vue?vue&type=script&lang=js&"
export * from "./AdminMainScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9a6182",
  null
  
)

export default component.exports